import { render, staticRenderFns } from "./DropdownTag.vue?vue&type=template&id=959346bc"
import script from "./DropdownTag.vue?vue&type=script&lang=js"
export * from "./DropdownTag.vue?vue&type=script&lang=js"
import style0 from "./DropdownTag.vue?vue&type=style&index=0&id=959346bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports